import { useState } from 'react';

import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { prepareFilter } from 'libs/common';
import { BenefitGrid } from './grid';
import Filter from './filter';

const sortInitial = [{ field_name: 'created_at', direction: 'desc' }];
const itemsInitial = {};

export const Discount = (props) => {
  const [items, setItems] = useState(itemsInitial);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('discount', sortInitial);

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    //console.log('🚀 ~ prepareParams ~ data:', data);
    const priceFields = ['amount_from', 'amount_to'];
    const addParams = { type: 'check' };
    return prepareFilter(data, addParams, { priceFields });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    clearEntries: () => setItems({}),
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return (
    <Controller {...props} {...gridParams} {...gridActions} type="benefit" filterName="discountFilter" grid={BenefitGrid} gridFilter={Filter} getRequestParams={prepareParams} />
  );
};
